const Component = () => import('./Search');

export { Component };
